module.exports = __webpack_public_path__ + "img/step_contact.798ad025.png";